// extracted by mini-css-extract-plugin
module.exports =  {"c-filters-text":"_025a50318d--c-filters-text--Ko8tG","c-filters-text--new-placement":"_025a50318d--c-filters-text--new-placement--EXR7O"};